module.exports = __webpack_public_path__ + "static/img/image_news_over_01.07b7ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_01.png
// module id = NZ73
// module chunks = 10